import managerApprovalService from '@/services/managerApprovalService'

const moduleState = {
  orders: [],
  isLoading: false,
  currentPage: 1,
  pageSize: 20,
  hasMorePages: true,
  searchText: '',
  searchPonId: '',
  error: null,
}

const mutations = {
  setOrders(state, orders) {
    state.orders = orders
  },
  addOrders(state, orders) {
    state.orders = state.orders.concat(orders)
  },
  setLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  setCurrentPage(state, page) {
    state.currentPage = page
  },
  setHasMorePages(state, hasMore) {
    state.hasMorePages = hasMore
  },
  setSearchText(state, query) {
    state.searchText = query
  },
  setSearchPonId(state, ponId) {
    state.searchPonId = ponId
  },
  setError(state, error) {
    state.error = error
  },
  removeOrder(state, quoteId) {
    state.orders = state.orders.filter((order) => order.QuoteId !== quoteId)
  },
  updateOrderStatus(state, { quoteId, status }) {
    const order = state.orders.find((o) => o.QuoteId === quoteId)
    if (order) {
      order.Status = status
    }
  },
  resetState(state) {
    state.orders = []
    state.currentPage = 1
    state.hasMorePages = true
    state.error = null
  },
}

const actions = {
  async fetchOrders({ commit, state, rootGetters }, { reset = false }) {
    if (state.isLoading) return

    commit('setLoading', true)
    commit('setError', null)

    try {
      if (reset) {
        commit('resetState')
      }

      const response = await managerApprovalService.getApprovalOverviewOrders(
        reset ? 0 : state.currentPage - 1,
        state.pageSize,
        state.searchText,
        state.searchPonId
      )

      // Handle new response structure with Results array
      const orders = response.data.Results || []

      if (reset) {
        commit('setOrders', orders)
      } else {
        commit('addOrders', orders)
      }

      commit('setCurrentPage', state.currentPage + 1)
      commit('setHasMorePages', orders.length === state.pageSize)
    } catch (error) {
      commit('setError', error.message || 'Failed to fetch orders')
      console.error('Error fetching manager approval orders:', error)
    } finally {
      commit('setLoading', false)
    }
  },

  async approveOrder({ commit, dispatch }, { quoteId, currentQuoteStatus, reason }) {
    try {
      await managerApprovalService.approveOrder(quoteId, currentQuoteStatus, reason)
      commit('removeOrder', quoteId)
      return { success: true }
    } catch (error) {
      console.error('Error approving order:', error)
      return { success: false, error: error.message || 'Failed to approve order' }
    }
  },

  async rejectOrder({ commit, dispatch }, { quoteId, currentQuoteStatus, reason }) {
    try {
      await managerApprovalService.rejectOrder(quoteId, currentQuoteStatus, reason)
      commit('removeOrder', quoteId)
      return { success: true }
    } catch (error) {
      console.error('Error rejecting order:', error)
      return { success: false, error: error.message || 'Failed to reject order' }
    }
  },

  updateFilters({ commit }, { searchText, searchPonId }) {
    if (searchText !== undefined) commit('setSearchText', searchText)
    if (searchPonId !== undefined) commit('setSearchPonId', searchPonId)
  },

  resetOrders({ commit }) {
    commit('resetState')
  },
}

const getters = {
  ordersCount: (state) => state.orders.length,
  isLoadingOrders: (state) => state.isLoading,
  hasError: (state) => !!state.error,
  canLoadMore: (state) => state.hasMorePages && !state.isLoading,
}

export default {
  namespaced: true,
  state: moduleState,
  mutations,
  actions,
  getters,
}
